import { render } from "./PriceBackfill.vue?vue&type=template&id=68887f78&scoped=true"
import script from "./PriceBackfill.vue?vue&type=script&lang=js"
export * from "./PriceBackfill.vue?vue&type=script&lang=js"

import "./PriceBackfill.vue?vue&type=style&index=0&id=68887f78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68887f78"]])

export default __exports__